import React from 'react'

import './Marble.less'

export enum MarbleColor {
  Empty = 'empty',
  Red = 'red',
  Yellow = 'yellow',
  Green = 'green'
}

export const Marble = ({ color }: { color: MarbleColor }) => (
  <div className={`Marble ${classForMarbleColor(color)}-bg`} />
)

// @ts-expect-error 9/11/2020
export const marbleColorForRating = (rating: number): MarbleColor => {
  switch (rating) {
    case 1:
    case 2:
      return MarbleColor.Red

    case 3:
      return MarbleColor.Yellow

    case 4:
    case 5:
      return MarbleColor.Green
  }
}

export const classForMarbleColorRating = (rating: number) =>
  classForMarbleColor(marbleColorForRating(rating))

export const classForMarbleColor = (color: MarbleColor) => `Marble-${color}`
